/*
 * @Author: Code-HHX
 * @Date: 2022-04-19 09:41:36
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-04-19 16:24:36
 * @Description:用户接口
 */
import {
  requestGet,
  requestPost,
  requestGetForm,
  requestPostForm,
  requestFileUpload
} from "../config/http-json";

import log from "@/util/log"
const user = {
  //账号注册
  async registerBrandUser(params = {}) {
    params.showProgress = true;
    let response = await requestPost("/omni/user/registerBrandUser", params);
    return response;
  },
  //账号注册
  async registerUser(params = {}) {
    params.showProgress = true;
    let response = await requestPost("/omni/user/registerUser", params);
    return response;
  },
  //登录
  async doLogin(params = {}) {
    let response = await requestPostForm("/omni/user/doLogin", params);
    return response;
  },
  //找回密码发送验证码
  async sendEmail(params = {}) {
    let response = await requestPostForm("/omni/user/sendEmail", params);
    return response;
  },
  //找回密码发送验证码
  async sendEmailV2(params = {}) {
    let response = await requestPostForm("/omni/user/sendEmailV2", params);
    return response;
  },
  //校验验证码
  async verificationCode(params = {}) {
    let response = await requestGetForm("/omni/user/verificationCode", params);
    return response;
  },
  //查询历史记录
  async selectUploadHistory(params = {}) {
    let response = await requestGetForm("/omni/user/selectUploadHistory", params, {
      showLoading: false
    });
    return response;
  },
  //查询历史记录
  async selectMyDevices(params = {}) {
    let response = await requestGetForm("/omni/user/selectMyDevices", params, {
      showLoading: false
    });
    return response;
  },
  //修改电压名称
  async updateVoltageName(params = {}) {
    let response = await requestPost("/omni/user/updateVoltageName", params);
    return response;
  },
  //保存电压
  async saveVoltageSettings(params = {}) {
    let response = await requestPost("/omni/user/saveVoltageSettings", params);
    return response;
  },
  //
  //updateVoltageName
  async retrievePassword(params = {}) {
    let response = await requestPostForm("/omni/user/retrievePassword", params);
    return response;
  },

  async deleteModeName(params = {}) {
    let response = await requestPostForm("/omni/user/deleteCurveById", params);
  },

  async verificationInvitationCode(params = {}) {
    const response = await requestGetForm("/omni/user/selectInvitationCode", params);
    return response;
  },
  async selectSubjectBySign(params) {
    const response = await requestGetForm("/omni/user/selectSubjectBySign", params);
    return response;
  },
  async uploadFile(params) {
    const response = await requestFileUpload("/omni/user/uploadFile", params);
    return response.data;
  },
  async updateUserProfile(params) {
    const response = await requestPost("/omni/user/update", params);
    return response.data;
  },
  async updateUserProfile2(params) {
    const response = await requestPost("/omni/user/update", params);
    return response;
  },
  async favoriteCurve(data, showProgress = false) {
    const resp = await requestPost("/omni/user/favoriteCurveHistory", data, { showProgress });
    return resp;
  },
  async favoriteRecommendCurve(data, showProgress = false) {
    const resp = await requestPost("/omni/user/favoriteRecommendedCurve", data, { showProgress });
    return resp;
  },
  async tagDetail(data, showProgress = false) {
    const resp = await requestGetForm("/omni/user/selectTagDetails", data, { showProgress });
    return resp.data;
  },
  async tagDetail2(data, showProgress = false) {
    const resp = await requestGetForm("/omni/user/selectTagDetails", data, { showProgress });
    return resp;
  },
  async updateProductName(data, showProgress = false) {
    const resp = await requestPost("/omni/user/updateProductName", data, { showProgress });
    return resp;
  },
  async fetchBtDeviceName(data, showProgress = false) {
    const params = data.map(item => `deviceMac=${item}`).join("&");
    log(params)
    const resp = await requestGet(`/omni/user/selectBatchDevice?${params}`, {}, { showProgress });
    return resp.data;
  },

  async checkAccountStatus(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/checkAccountStatus`, data, { showProgress });
    return resp.data;
  },
  async sendEmailVerification(data, showProgress = false) {
    const resp = await requestPost(`/omni/user/sendVerificationCode`, data, { showProgress });
    return resp;
  },
  async verificationCodeCheck(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/verificationCode`, data, { showProgress });
    return resp;
  },

  async brandEvents(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/selectBrandEvent`, data, { showProgress });
    return resp;
  },
  async eventDetail(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/selectBrandEventById`, data, { showProgress });
    return resp.data;
  },

  async userCaptcha(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/captcha`, data, { showProgress });
    return resp.data;
  },
  async checkUserCaptcha(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/checkVerificationCode`, data, { showProgress });
    return resp;
  },
  async verifyTag(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/verifyTag`, data, { showProgress });
    return resp;
  },
  async agreementRead(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/agreementRead`, data, { showProgress });
    return resp;
  },
  async favoriteDevice(data, showProgress = false) {
    const resp = await requestPost(`/omni/user/favoriteDevice`, data, { showProgress });
    return resp;
  },
  async selectAdvertise(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/selectAdvertise`, data, { showProgress });
    return resp;
  },
  async identityConfirm(data, showProgress = false) {
    const resp = await requestGetForm(`/omni/user/identityConfirm`, data, { showProgress });
    return resp;
  },
  async resetPassword(data, showProgress = false) {
    const resp = await requestPost(`/omni/user/resetPassword`, data, { showProgress });
    return resp;
  },
  async myFavoriteDevice(data, showProgress = false) {
    const resp = await requestGet(`/omni/user/selectMyDevicesByBrandId`, data, { showProgress });
    return resp;
  },

};

export default user;
